require('regenerator-runtime/runtime');

var _require = require('./utils/log'),
    logging = _require.logging,
    setLogging = _require.setLogging;

var createWorker = require('./createWorker');

module.exports = {
  logging: logging,
  setLogging: setLogging,
  createWorker: createWorker
};